import { isTauri } from "../desktop";

// Where members install the Grackle browser extension (FR-X1: Chrome Web Store, with an Edge
// build from the same source). Null until the listing is published; the Live notes page then
// says so instead of linking to a store page that doesn't exist yet.
export const EXTENSION_INSTALL_URL: string | null = null;

/**
 * Whether this browser can run the extension: desktop Chromium (FR-X1's Chrome and Edge, plus
 * Brave, Opera and the like, which install from the Chrome Web Store). Not Firefox or Safari,
 * not mobile, and not the desktop app's webview even where that is Chromium. Only Chromium
 * exposes `navigator.userAgentData`, so its absence is a clean "no".
 */
export function browserCanUseExtension(): boolean {
  if (isTauri()) return false;
  const ua = (navigator as Navigator & { userAgentData?: { brands: { brand: string }[]; mobile: boolean } })
    .userAgentData;
  return Boolean(ua && !ua.mobile && ua.brands.some((b) => b.brand === "Chromium"));
}
